module.exports = __webpack_public_path__ + "static/media/test_1.c3d44b64.jpg";